const initialState = {
  venue: null,
  userWon: false,
  prize: null,
  joke: null,
};

export default initialState;
